import React from "react";

import {
  SwaggerTicketDao,
  TicketService,
  TicketSwagger,
} from "@egis-smartcity/parking";
import TicketContext, { TicketState } from "./TicketContext";
import useAuth from "../../hooks/useAuth";
import useCityConfig from "../../hooks/useCityConfig";

export type TicketProviderProps = React.PropsWithChildren<{}>;

function TicketProvider(props: TicketProviderProps) {
  const { children } = props;
  const { cityConfig } = useCityConfig();
  const { token } = useAuth();

  const ticketService: TicketService | undefined = React.useMemo(() => {
    if (!cityConfig || !token) return;

    const ticketControlSwaggerClient = new TicketSwagger.TicketApi(
      new TicketSwagger.Configuration({
        basePath: cityConfig.review.ticket.url,
        apiKey: `Bearer ${token}`,
      })
    );
    const swaggerTicketDao = new SwaggerTicketDao(ticketControlSwaggerClient);

    return new TicketService(swaggerTicketDao);
  }, [cityConfig, token]);

  const ticketState: TicketState = React.useMemo(() => {
    return { ticketService };
  }, [ticketService]);

  return (
    <TicketContext.Provider value={ticketState}>
      {children}
    </TicketContext.Provider>
  );
}

export default TicketProvider;
